import { Link, Outlet } from "react-router-dom";
import Sidebar from "../components/admin/Sidebar";
import BackToTop from "../components/BackToTop";
import useAuthStore from "../store/authStore";
import { useEffect, useState } from "react";
import { FaLock } from "react-icons/fa";

export default function AdminLayout() {
  const { user, getUser, logout, isLoading } = useAuthStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUser().then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="fixed inset-0 flex justify-center items-center z-50">
        <div className="animate-spin rounded-full h-5 w-5 border-t-4 mr-4 border-b-4 border-secondary" />
        <span className="font-nunito text-[14px] text-secondary">
          Chargement...
        </span>
      </div>
    );
  } else {
    // console.log({user})
    if (
      !user ||
      (user?.role?.name && !["superadmin", "manager"].includes(user.role.name))
    ) {
      console.log("Accès interdit");
      return (
        <div className="h-screen w-full flex flex-col justify-center items-center bg-gray-50 text-center px-4">
          <FaLock size={60} className="text-gray-300 mb-4" />
          <h1 className="font-poppins font-semibold text-[18px] text-title mb-2">
            Accès interdit
          </h1>
          <p className="font-nunito text-[14px] text-text mb-6">
            Vous n'avez pas les autorisations nécessaires pour accéder à cette
            page.
          </p>
          <Link
            to="/"
            className="inline-block bg-primary text-white px-6 py-2 rounded-md hover:bg-secondary-700 transition-colors duration-200 font-nunito font-semibold text-[14px]"
            title="Retour à l'accueil"
          >
            Retour à l'accueil
          </Link>
        </div>
      );
    }
  }

  return (
    <div className="flex h-screen">
      <Sidebar />
      <main className="md:max-h-[95vh] w-full overflow-y-auto p-6 bg-gray-50">
        <Outlet />
      </main>
      {/* <BackToTop /> */}
    </div>
  );
}
